export default "__VITE_ASSET___IFYw9xY__"